import { Component, Inject, OnInit } from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialog,
  MatDialogRef,
} from '@angular/material/dialog';
import { Candidate } from 'src/app/interfaces/Candidate';
import { LocalService } from 'src/app/services/local.service';
import { PuzzleService } from 'src/app/services/puzzle.service';
import { environment } from 'src/environments/environment';
import { ResponseSmallDialogComponent } from '../response-small-dialog/response-small-dialog.component';
import { APIResponse } from 'src/app/interfaces/response';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-send-quest-by-email',
  templateUrl: './send-quest-by-email.component.html',
  styleUrls: ['./send-quest-by-email.component.css'],
})
export class SendQuestByEmailComponent implements OnInit {
  vacancyName: string = '';
  candidateName: string = '';
  token: string = '';
  urlWithToken: string = '';
  userName: string = '';
  sending: boolean = false;
  candidateId: string = '';
  email: string = '';

  constructor(
    private localService: LocalService,
    private puzzleService: PuzzleService,
    private translate: TranslateService,
    private dialog: MatDialog,
    private dialogRef: MatDialogRef<SendQuestByEmailComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    const candidate: Candidate = data.candidate;
    this.email = candidate.cdT_EMAIL;

    if (!this.email || this.email === '' || this.email === 'Sin email') {
      this.openResultDialog(
        0,
        this.translate.instant('questionnaireNoEmailError'),
      );
      this.closeModal();
    }

    this.vacancyName = candidate.cdT_JOB_INFO?.joB_NAME;
    this.candidateName =
      candidate.cdT_NAME +
      ' ' +
      candidate.cdT_PATERNAL_SURNAME +
      ' ' +
      candidate.cdT_MATERNAL_SURNAME;
    this.token = data.token;
    this.candidateId = candidate.cdT_ID;

    const userToken = this.localService.getJsonValue('token');
    this.userName = userToken.data.name + ' ' + userToken.data.lastName;
    let companyName = '';
    if (userToken.data.parentCompanyName) {
      companyName = this.removeSpecialCharactersAndSpaces(
        userToken.data.parentCompanyName,
      );
    } else {
      companyName = this.removeSpecialCharactersAndSpaces(
        userToken.data.companyName,
      );
    }

    this.urlWithToken =
      environment.candidateUrl + companyName + '/CF?id=' + this.token;
  }

  ngOnInit(): void {}

  closeModal() {
    this.dialogRef.close();
  }

  removeSpecialCharactersAndSpaces(text: string): string {
    text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    return text.replace(/[^a-zA-Z0-9]/g, '');
  }

  sendQuest() {
    if (this.sending) return;

    const questData = {
      candidatesIds: [{ candidateId: this.candidateId }],
    };

    const loadingMessage = this.translate.instant(
      'candidateCFEmailAlertLoading',
    );
    const loading = this.openResultDialog(2, loadingMessage);
    this.sending = true;

    this.puzzleService
      .sendQuestionnaireByEmail(questData)
      .subscribe((res: APIResponse) => {
        if (res.isSuccess) {
          this.openResultDialog(
            1,
            this.translate.instant('questionnaireSent'),
          );
        } else {
          this.openResultDialog(
            0,
            this.translate.instant('questionnaireSentError'),
          );
        }
        this.sending = false;
        loading.close();
        this.dialogRef.close(true);
      });
  }

  openResultDialog(mode: number, message?: string, content?: string) {
    let data: string[] = [];
    switch (mode) {
      case 0:
        {
          data.push('Error');
          data.push(message);
          if (content) data.push(content);
          return this.dialog.open(ResponseSmallDialogComponent, {
            width: '500px',
            data: data,
          });
        }
        break;
      case 1:
        {
          data.push('Exito');
          data.push(message);
          if (content) data.push(content);

          return this.dialog.open(ResponseSmallDialogComponent, {
            width: '500px',
            data: data,
          });
        }
        break;
      case 2:
        {
          data.push('loading');
          data.push(message);
          if (content) data.push(content);

          return this.dialog.open(ResponseSmallDialogComponent, {
            width: '500px',
            data: data,
            disableClose: true,
          });
        }
        break;
    }
  }
}
